// XRPLSendTransaction.js
import React, { useEffect, useRef, useState } from "react";
import core from '@joey-wallet/wc-client/core';
import {
  Form,
  FormButton,
  FormButton1,
  FormContainer,
  FormContent,
  FormH1,
  FormText,
  FormWrapper,
} from "../../CustomForm/CustomFormElements";
import { ALERT_TYPES, TRANSACTION_OPTIONS } from "../../../utils/Enum";
import { useAuth } from "../../../contexts/AuthContext";
import { useAlert } from "../../Alert/AlertContext";
import axiosInstance from "../../Authorization/client";
import useArtist from "../../../hooks/useArtist";
import {
  getSignTxStatus,
  updateSignTxStatus,
} from "../../../utils/dbUtils/signTxUtils";
import { ModalLoadingScreen } from "../../LoadingScreen";
import { useWebsiteTheme } from "../../WebsiteTheme/WebsiteThemeContext";
import { Small, TextRoute } from "../../SignUp/SignUpElements";
import { useXRPLWalletConnect } from "../../../hooks/xrplAppKit/XRPLWalletProvider";
import { useJoeyWallet } from "../../../hooks/xrplAppKit/joeyWallet/JoeyWalletProvider";

export function XRPLSendTransaction({
  topic,
  account,
  payload,
  invoice,
  method,
  onSuccess,
  onFail,
  cancel,
  disconnect,
  type,
  body,
  heading,
}) {
  const { artistProfileChecker } = useArtist({
    id: body?.artistId,
  });
  const {client} = useXRPLWalletConnect()
  const { themeColors } = useWebsiteTheme();
  const [status, setStatus] = useState("idle");
  const [isWaiting, setIsWaiting] = useState(false);
  const { currentUser } = useAuth();
  const { addAlert } = useAlert();
  const [offers, setOffers] = useState([]);
  const [response, setResponse] = useState({});
  // Ref to ensure auto-trigger only runs once
  const hasTriggered = useRef(false);
  // AUTO-TRIGGER: Run handleSign once when component mounts
  useEffect(() => {
    if (!hasTriggered.current && topic && account) {
      hasTriggered.current = true;
      handleSign();
    }
  }, [topic, account]);

  useEffect(() => {
    if (invoice) {
      getSignTxStatus(invoice, status, setStatus, setResponse);
    }
    return () => {};
  }, [invoice]);

  useEffect(() => {
    if (invoice) {
      if (status === "success" && response !== false) {
        dispatch(response);
      }
      if (status === "success" && response === false) {
        addAlert({
          title: `${type}`,
          type: ALERT_TYPES.DANGER,
          message: `The transaction was unsuccessful`,
        });
        onFail();
      }
      if (status === "error") {
        addAlert({
          title: `${type}`,
          type: ALERT_TYPES.DANGER,
          message: `The transaction was unsuccessful`,
        });
        onFail();
      }
    }
    return () => {};
  }, [status, invoice]);

  

  const dispatch = async (response) => {
    switch (type) {
      case TRANSACTION_OPTIONS.SIGN_UP:
        onSuccess({
          ...response,
          address: response?.address,
        });
        addAlert({
          title: "Sign Up",
          type: ALERT_TYPES.SUCCESS,
          message: `Platform sign up was successful`,
        });
        return;
      case TRANSACTION_OPTIONS.SIGN_IN:
        onSuccess(response?.address);
        return;
      case TRANSACTION_OPTIONS.TIP_USER:
        addAlert({
          title: "User Tipping",
          type: ALERT_TYPES.SUCCESS,
          message: `Tipping ${body.sender.substring(
            0,
            4,
          )}...${body.sender.substring(body.sender.length - 5)} was Successful`,
        });
        onSuccess();
        return;

      case TRANSACTION_OPTIONS.SWERL_TIP:
        addAlert({
          title: "Swerl Tipper",
          type: ALERT_TYPES.SUCCESS,
          message: response?.message,
        });
        onSuccess(response?.txHash);
        return;

      case TRANSACTION_OPTIONS.ROYALTY_TRUSTLINE_SET:
        onSuccess({
          ...response,
          address: response?.address,
        });
        addAlert({
          title: "Royalty Share Token Trustline",
          type: ALERT_TYPES.SUCCESS,
          message: `Royalty Share Token Trustline Set was Successful`,
        });
        return;

      case TRANSACTION_OPTIONS.SUBSCRIBE_TO_ARTIST:
        addAlert({
          title: "Artist Subscription",
          type: ALERT_TYPES.SUCCESS,
          message: `Artist subscription successful`,
        });
        onSuccess();
        return;
        break;

      case TRANSACTION_OPTIONS.COMMENT:
        addAlert({
          title: "Posting Comment",
          type: ALERT_TYPES.SUCCESS,
          message: `Comment successfully posted`,
        });
        onSuccess();
        return;
        break;

      case TRANSACTION_OPTIONS.ARTIST_PROFILE_CHECKER:
        return await artistProfileChecker(response?.address)
          .then((res) => {
            return onSuccess({ ...res, address: response?.address }, body.type);
          })
          .catch((err) => {
            return onFail(err);
          });

      case TRANSACTION_OPTIONS.ARTIST_REGISTRATION:
        addAlert({
          title: "Artist Registration",
          type: ALERT_TYPES.SUCCESS,
          message: "Artist Registration Enabled",
        });
        return onSuccess(true);

      case TRANSACTION_OPTIONS.ENABLE_PUSH_NOTIFICATIONS:
        addAlert({
          title: "Push Notifications",
          type: ALERT_TYPES.SUCCESS,
          message: "Push Notifications Enabled",
        });
        return onSuccess(true);

      case TRANSACTION_OPTIONS.DISABLE_PUSH_NOTIFICATIONS:
        addAlert({
          title: "Push Notifications",
          type: ALERT_TYPES.SUCCESS,
          message: "Push Notifications Disabled",
        });

        return onSuccess(false);

      case TRANSACTION_OPTIONS.UPDATE_USER_PROFILE:
        addAlert({
          title: "Profile Update",
          type: ALERT_TYPES.SUCCESS,
          message: "User Profile Update Successful",
        });
        return onSuccess();

      case TRANSACTION_OPTIONS.DIGITAL_SONG_PURCHASE:
        onSuccess({
          ...response,
          address: response?.address,
        });
        addAlert({
          title: "Digital Song Purchase",
          type: ALERT_TYPES.SUCCESS,
          message: `Song Purchase was Successful`,
        });
        return;

      case TRANSACTION_OPTIONS.DIGITAL_ALBUM_PURCHASE:
        onSuccess({
          ...response,
          address: response?.address,
        });
        addAlert({
          title: "Digital Album Purchase",
          type: ALERT_TYPES.SUCCESS,
          message: `Album Purchase was Successful`,
        });
        return;
      case TRANSACTION_OPTIONS.PURCHASE_MUSIC_ROYALTY:
        onSuccess(response);

        addAlert({
          title: "Music Regium Shares Purchase",
          type: ALERT_TYPES.SUCCESS,
          message: `Music Regium Shares Purchase Was Successful`,
        });
        break;

      case TRANSACTION_OPTIONS.GIFT_MUSIC_ROYALTY:
        onSuccess(response);

        addAlert({
          title: "Music Regium Shares Gift",
          type: ALERT_TYPES.SUCCESS,
          message: `Music Regium Shares Gifting Was Successful`,
        });
        break;

      case TRANSACTION_OPTIONS.CLAIM_MUSIC_ROYALTY_RESERVES:
        onSuccess(response);

        addAlert({
          title: "Music Regium Shares Reserves Claim",
          type: ALERT_TYPES.SUCCESS,
          message: `Music Regium Shares Reserves Claim Was Successful`,
        });
        break;

      case TRANSACTION_OPTIONS.CREATE_NFTOKEN_COLLECTION:
        onSuccess({
          name: body.title,
          mintInfo: { taxon: body.taxon },
          collectionId: response?.collectionId,
        });

        addAlert({
          title: "NFToken Collection Creation",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Collection Creation Was Successful`,
        });
        return;

      case TRANSACTION_OPTIONS.NFTOKEN_PURCHASE:
        onSuccess({ offers: response?.offers, collection: body.collection });
        addAlert({
          title: "NFToken Purchase",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Purchase Was Successful`,
        });

        //insert hook before purchase
        break;

      case TRANSACTION_OPTIONS.NFTOKEN_GIFT:
        onSuccess({ ...response });
        addAlert({
          title: "Gifting NFToken",
          type: ALERT_TYPES.SUCCESS,
          message: `Gifting NFToken Was Successful`,
        });
        //insert hook before purchase
        break;

      case TRANSACTION_OPTIONS.NFTOKEN_BURN:
        addAlert({
          title: "NFToken Burn",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Burn Was Successful`,
        });
        return onSuccess();

      case TRANSACTION_OPTIONS.NFTOKEN_TRANSFER:
        addAlert({
          title: "NFToken Transfer",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Transfer Was Successful`,
        });
        return onSuccess();

      case TRANSACTION_OPTIONS.NFTOKEN_MINT:
        onSuccess({ ...body, tokenId: response?.tokenId });
        addAlert({
          title: "NFToken Mint",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Mint Was Successful`,
        });
        return;

      case TRANSACTION_OPTIONS.UPDATE_DYNAMIC_NFTOKEN:
        onSuccess({ ...body });
        addAlert({
          title: "NFToken Update",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Update Was Successful`,
        });
        return;

      case TRANSACTION_OPTIONS.NFTOKEN_OFFER_ACCEPT:
        onSuccess({
          ...response,
          collection: body?.collection,
        });
        addAlert({
          title: "NFToken(s) Claim",
          type: ALERT_TYPES.SUCCESS,
          message: `Successfully Claimed An NFToken`,
        });
        return;

      case TRANSACTION_OPTIONS.NFTOKEN_OFFERS_ACCEPT:
        let remainingOffers = offers.filter((offer, index) => index !== 0);
        onSuccess({
          ...response,
          collection: body.collection,
          offers: remainingOffers,
        });
        addAlert({
          title: "NFToken(s) Claim",
          type: ALERT_TYPES.SUCCESS,
          message: `Successfully Claimed An NFToken`,
        });
        return;

      case TRANSACTION_OPTIONS.SWERL_VOUCHER_OFFERS_ACCEPT:
        /*        let remainingOffers = offers.filter(
            (offer, index) => index !== 0
          ); */

        addAlert({
          title: "Vouchers(s) Claim",
          type: ALERT_TYPES.SUCCESS,
          message: `Successfully Claimed An Voucher`,
        });
        return onSuccess({
          ...response,
          collection: body.collection,
          offers: remainingOffers,
        });

      case TRANSACTION_OPTIONS.DEACTIVATE_USER_ACCOUNT:
        return; /* deactivateUser(body, body.type, {
            txid: data.txid,
            payload: data.payload_uuidv4,
          })
            .then((data) => {
              if (!data.error || data !== false) {
                onSuccess();
                addAlert({
                  title: "User Account Deactivation",
                  type: ALERT_TYPES.SUCCESS,
                  message: `Successfully deactivated account`,
                });
                return;
              }
              addAlert({
                title: "User Account Deactivation",
                type: ALERT_TYPES.SUCCESS,
                message: `Account Deactivation Successful`,
              });
            })
            .catch((err) => {
              onFail();
              addAlert({
                title: "User Account Deactivation",
                type: ALERT_TYPES.DANGER,
                message: `Account Deactivation Unsuccessful`,
              });
            }); */

      case TRANSACTION_OPTIONS.PAY_STREAMING_SUBSCRIPTION:
        addAlert({
          title: "Sonar Muse Streaming Subscription",
          type: ALERT_TYPES.SUCCESS,
          message: `Subscription Payment Successful`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.PAY_AS_YOU_GO_STREAMING_SUBSCRIPTION:
        addAlert({
          title: "Sonar Muse Pay As You Go (PAYG) Streaming Subscription",
          type: ALERT_TYPES.SUCCESS,
          message: `Subscription Payment Successful`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.TOP_UP_STREAMING_SUBSCRIPTION:
        addAlert({
          title: "Sonar Muse Streaming Subscription Top Up",
          type: ALERT_TYPES.SUCCESS,
          message: `Subscription Top Up Successful`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.TOP_UP_TIPPING_FUNDS:
        addAlert({
          title: "Sonar Muse Swərl Tipping Top Up",
          type: ALERT_TYPES.SUCCESS,
          message: `Subscription Top Up Successful`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.REDEEM_SWERL_VOUCHER:
        addAlert({
          title: "Sonar Muse Streaming Subscription",
          type: ALERT_TYPES.SUCCESS,
          message: `Subscription Payment Successful`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.PURCHASE_SWERL_VOUCHER:
        addAlert({
          title: "Purchasing Swerl Streaming Voucher",
          type: ALERT_TYPES.SUCCESS,
          message: `Streaming Voucher Purchase Successful`,
        });
        return onSuccess({ offers: response.offers });

        break;

      case TRANSACTION_OPTIONS.ENABLE_WEB_MONETIZATION:
        addAlert({
          title: "Enabling Web Monetization",
          type: ALERT_TYPES.SUCCESS,
          message: `Web Monetization Successfully Enabled`,
        });
        return onSuccess({
          paymentChannel: response?.paymentChannel,
          funds: response?.funds,
        });

        break;

      case TRANSACTION_OPTIONS.AUTHORIZE_MONETIZATION_CLAIM:
        addAlert({
          title: "Authorization Receipt",
          type: ALERT_TYPES.SUCCESS,
          message: `Authorization Receipt Created Successfully`,
        });
        return onSuccess(response?.hex, response?.signer_pubkey);

        break;

      case TRANSACTION_OPTIONS.AUTHORIZE_MONETIZATION_DISABLE:
        addAlert({
          title: "Authorization Receipt",
          type: ALERT_TYPES.SUCCESS,
          message: `Authorization Receipt Created Successfully`,
        });
        return onSuccess(
          response.payload_uuidv4,
          response.txid,
          response?.hex,
          response?.data?.signer_pubkey,
        );

        break;

      case TRANSACTION_OPTIONS.CLAIM_MONETIZATION_FUNDS:
        //let address = value?.data?.address;
        addAlert({
          title: "Micropayment Funds Claim",
          type: ALERT_TYPES.SUCCESS,
          message: `Micropayments Fund Claim Successful`,
        });
        return onSuccess();
        break;

      case TRANSACTION_OPTIONS.DISABLE_WEB_MONETIZATION:
        break;

      case TRANSACTION_OPTIONS.COLLECTION_WHITELIST:
        addAlert({
          title: "Collection Whitelist",
          type: ALERT_TYPES.SUCCESS,
          message: `Collection whitelist updated successfully`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.GET_MUSIC_LIBRARY:
        //console.log(data)
        let address = response?.address;

        return onSuccess(address);

      case TRANSACTION_OPTIONS.GET_ACCOUNT_INFO:
        return onSuccess(response?.address);

      case TRANSACTION_OPTIONS.NFTOKEN_DISCOUNT:
        //console.log(data)
        return onSuccess(address);

      case TRANSACTION_OPTIONS.PODCASTER_REGISTRATION:
        break;

      case TRANSACTION_OPTIONS.MARKETING_CAMPAIGN:
        addAlert({
          title: "Marketing Campaign",
          type: ALERT_TYPES.DANGER,
          message: `Marketing Campaign Creation Successful`,
        });
        return onSuccess();

        break;

      default:
        return onSuccess(response)
        break;
    }
  };

  const handleSign = async () => {
    setIsWaiting(true);
    return await client.request({
    chainId: "xrpl:0",
    topic,
    request: {
      method: method,
      params: payload?.memo
        ?  {
            tx_json: {
              SourceTag: 510162502,
              Memos: [
                {
                  Memo: {
                    MemoData: payload.memo,
                  },
                },
              ],
              Account: account,
              TransactionType: "Payment",
              Amount: "1",
              Destination: "rrrrrrrrrrrrrrrrrNAMEtxvNvQ",
            },
            autofill: true,
            submit: false,
          }
         : { tx_json: { ...payload }}  // Account is required for sign-only
    },
  }).then(async (result) => {
        const response = result?.result || result;
        if (response?.tx_json) {
          await updateSignTxStatus(invoice, {
            txHash: payload?.memo ? response?.tx_json : response?.tx_json?.hash,
            isOffChain: payload?.memo ? true : false,
            ...response,
            signed: true,
          });
        } else {
          await updateSignTxStatus(invoice, {
            signed: false,
          });
          onFail();
        }
      })
      .catch(async (err) => {
        console.error("Sign error:", err);
        onFail(); 
        if (err.message.includes("Non conforming namespaces")) {
          alert("Session Expired. Reconnecting...");
         // Force clean state
          await updateSignTxStatus(invoice, {
            txHash: response?.tx_json.hash,
            ...response,
            signed: false,
          });
        }
      })
      .finally(() => {
        setIsWaiting(false);
      });
  };

  return (
    <FormWrapper>
      {(status === "idle" || !status) && (
        <Form>
          <FormH1>{heading}</FormH1>

          <div
            style={{
              textAlign: "center",
              marginBottom: "20px",
              padding: "0 10px",
            }}
          >
            {isWaiting ? (
              <>
                <FormText
                  style={{
                    fontWeight: "bold",
                    marginBottom: "8px",
                  }}
                >
                  Please open your wallet to sign the transaction.
                </FormText>
                <br/>
                <FormText style={{ color: themeColors.accentColor }}>
                  Keep this page open while signing.
                </FormText>
              </>
            ) : (
              <FormText style={{ color: themeColors.accentColor }}>
                Ready to sign transaction.
              </FormText>
            )}
            
          </div>

          {/* BUTTON (Acts as Manual Retry if auto-trigger missed) */}
          <FormButton
            to={"#"}
            onClick={handleSign}
            disabled={status === "processing"}
          >
            {isWaiting
              ? "Transaction didn't pop up? Click to Retry"
              : "Confirm & Sign"}
          </FormButton>
          {type === TRANSACTION_OPTIONS.SIGN_UP && (
            <>
              <Small>
                New to web3 or the XRPL? Learn more about how to sign up{" "}
                <TextRoute to="/faq"> here</TextRoute>
              </Small>
              <Small>
                Already have an account?{" "}
                <TextRoute to="/access/signin">Sign in</TextRoute>
              </Small>
            </>
          )}
          {type === TRANSACTION_OPTIONS.SIGN_IN && (
            <>
              <Small>
                Don't have an account?{" "}
                <TextRoute to="/access/signup">Sign up</TextRoute>
              </Small>
              <Small>
                Have an artist account? Visit the{" "}
                <TextRoute
                  target="_blank"
                  rel="noopener noreferrer"
                  to="https://artists.sonarmuse.org"
                >
                  Sonar Muse for Artists
                </TextRoute>{" "}
                portal to sign in
              </Small>
            </>
          )}
          <FormButton1 transparent onClick={cancel}>Cancel</FormButton1>
        </Form>
      )}

      {(status === "loading" || status === "processing") && (
        <ModalLoadingScreen
          text={
            status === "processing"
              ? "Processing Transaction. Please Wait..."
              : "Loading. Please Wait..."
          }
          transparent={true}
        />
      )}
    </FormWrapper>
  );
}



export function JoeySendTransaction({
  topic,
  account,
  payload,
  invoice,
  method,
  onSuccess,
  onFail,
  cancel,
  disconnect,
  type,
  body,
  heading,
}) {
  const { artistProfileChecker } = useArtist({
    id: body?.artistId,
  });
  const { provider, session, chain } = useJoeyWallet();
  const { themeColors } = useWebsiteTheme();
  const [status, setStatus] = useState("idle");
  const [isWaiting, setIsWaiting] = useState(false);
  const { currentUser } = useAuth();
  const { addAlert } = useAlert();
  const [offers, setOffers] = useState([]);
  const [response, setResponse] = useState({});
  // Ref to ensure auto-trigger only runs once
  const hasTriggered = useRef(false);
  // AUTO-TRIGGER: Run handleSign once when component mounts
  useEffect(() => {
    if (!hasTriggered.current && topic && account) {
      hasTriggered.current = true;
      handleSign();
    }
  }, [topic, account]);

  useEffect(() => {
    if (invoice) {
      getSignTxStatus(invoice, status, setStatus, setResponse);
    }
    return () => {};
  }, [invoice]);

  useEffect(() => {
    if (invoice) {
      if (status === "success" && response !== false) {
        dispatch(response);
      }
      if (status === "success" && response === false) {
        addAlert({
          title: `${type}`,
          type: ALERT_TYPES.DANGER,
          message: `The transaction was unsuccessful`,
        });
        onFail();
      }
      if (status === "error") {
        addAlert({
          title: `${type}`,
          type: ALERT_TYPES.DANGER,
          message: `The transaction was unsuccessful`,
        });
        onFail();
      }
    }
    return () => {};
  }, [status, invoice]);
console.log({account})
  

  const dispatch = async (response) => {
    switch (type) {
      case TRANSACTION_OPTIONS.SIGN_UP:
        onSuccess({
          ...response,
          address: response?.address,
        });
        addAlert({
          title: "Sign Up",
          type: ALERT_TYPES.SUCCESS,
          message: `Platform sign up was successful`,
        });
        return;
      case TRANSACTION_OPTIONS.SIGN_IN:
        onSuccess(response?.address);
        return;
      case TRANSACTION_OPTIONS.TIP_USER:
        addAlert({
          title: "User Tipping",
          type: ALERT_TYPES.SUCCESS,
          message: `Tipping ${body.sender.substring(
            0,
            4,
          )}...${body.sender.substring(body.sender.length - 5)} was Successful`,
        });
        onSuccess();
        return;

      case TRANSACTION_OPTIONS.SWERL_TIP:
        addAlert({
          title: "Swerl Tipper",
          type: ALERT_TYPES.SUCCESS,
          message: response?.message,
        });
        onSuccess(response?.txHash);
        return;

      case TRANSACTION_OPTIONS.ROYALTY_TRUSTLINE_SET:
        onSuccess({
          ...response,
          address: response?.address,
        });
        addAlert({
          title: "Royalty Share Token Trustline",
          type: ALERT_TYPES.SUCCESS,
          message: `Royalty Share Token Trustline Set was Successful`,
        });
        return;

      case TRANSACTION_OPTIONS.SUBSCRIBE_TO_ARTIST:
        addAlert({
          title: "Artist Subscription",
          type: ALERT_TYPES.SUCCESS,
          message: `Artist subscription successful`,
        });
        onSuccess();
        return;
        break;

      case TRANSACTION_OPTIONS.COMMENT:
        addAlert({
          title: "Posting Comment",
          type: ALERT_TYPES.SUCCESS,
          message: `Comment successfully posted`,
        });
        onSuccess();
        return;
        break;

      case TRANSACTION_OPTIONS.ARTIST_PROFILE_CHECKER:
        return await artistProfileChecker(response?.address)
          .then((res) => {
            return onSuccess({ ...res, address: response?.address }, body.type);
          })
          .catch((err) => {
            return onFail(err);
          });

      case TRANSACTION_OPTIONS.ARTIST_REGISTRATION:
        addAlert({
          title: "Artist Registration",
          type: ALERT_TYPES.SUCCESS,
          message: "Artist Registration Enabled",
        });
        return onSuccess(true);

      case TRANSACTION_OPTIONS.ENABLE_PUSH_NOTIFICATIONS:
        addAlert({
          title: "Push Notifications",
          type: ALERT_TYPES.SUCCESS,
          message: "Push Notifications Enabled",
        });
        return onSuccess(true);

      case TRANSACTION_OPTIONS.DISABLE_PUSH_NOTIFICATIONS:
        addAlert({
          title: "Push Notifications",
          type: ALERT_TYPES.SUCCESS,
          message: "Push Notifications Disabled",
        });

        return onSuccess(false);

      case TRANSACTION_OPTIONS.UPDATE_USER_PROFILE:
        addAlert({
          title: "Profile Update",
          type: ALERT_TYPES.SUCCESS,
          message: "User Profile Update Successful",
        });
        return onSuccess();

      case TRANSACTION_OPTIONS.DIGITAL_SONG_PURCHASE:
        onSuccess({
          ...response,
          address: response?.address,
        });
        addAlert({
          title: "Digital Song Purchase",
          type: ALERT_TYPES.SUCCESS,
          message: `Song Purchase was Successful`,
        });
        return;

      case TRANSACTION_OPTIONS.DIGITAL_ALBUM_PURCHASE:
        onSuccess({
          ...response,
          address: response?.address,
        });
        addAlert({
          title: "Digital Album Purchase",
          type: ALERT_TYPES.SUCCESS,
          message: `Album Purchase was Successful`,
        });
        return;
      case TRANSACTION_OPTIONS.PURCHASE_MUSIC_ROYALTY:
        onSuccess(response);

        addAlert({
          title: "Music Regium Shares Purchase",
          type: ALERT_TYPES.SUCCESS,
          message: `Music Regium Shares Purchase Was Successful`,
        });
        break;

      case TRANSACTION_OPTIONS.GIFT_MUSIC_ROYALTY:
        onSuccess(response);

        addAlert({
          title: "Music Regium Shares Gift",
          type: ALERT_TYPES.SUCCESS,
          message: `Music Regium Shares Gifting Was Successful`,
        });
        break;

      case TRANSACTION_OPTIONS.CLAIM_MUSIC_ROYALTY_RESERVES:
        onSuccess(response);

        addAlert({
          title: "Music Regium Shares Reserves Claim",
          type: ALERT_TYPES.SUCCESS,
          message: `Music Regium Shares Reserves Claim Was Successful`,
        });
        break;

      case TRANSACTION_OPTIONS.CREATE_NFTOKEN_COLLECTION:
        onSuccess({
          name: body.title,
          mintInfo: { taxon: body.taxon },
          collectionId: response?.collectionId,
        });

        addAlert({
          title: "NFToken Collection Creation",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Collection Creation Was Successful`,
        });
        return;

      case TRANSACTION_OPTIONS.NFTOKEN_PURCHASE:
        onSuccess({ offers: response?.offers, collection: body.collection });
        addAlert({
          title: "NFToken Purchase",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Purchase Was Successful`,
        });

        //insert hook before purchase
        break;

      case TRANSACTION_OPTIONS.NFTOKEN_GIFT:
        onSuccess({ ...response });
        addAlert({
          title: "Gifting NFToken",
          type: ALERT_TYPES.SUCCESS,
          message: `Gifting NFToken Was Successful`,
        });
        //insert hook before purchase
        break;

      case TRANSACTION_OPTIONS.NFTOKEN_BURN:
        addAlert({
          title: "NFToken Burn",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Burn Was Successful`,
        });
        return onSuccess();

      case TRANSACTION_OPTIONS.NFTOKEN_TRANSFER:
        addAlert({
          title: "NFToken Transfer",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Transfer Was Successful`,
        });
        return onSuccess();

      case TRANSACTION_OPTIONS.NFTOKEN_MINT:
        onSuccess({ ...body, tokenId: response?.tokenId });
        addAlert({
          title: "NFToken Mint",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Mint Was Successful`,
        });
        return;

      case TRANSACTION_OPTIONS.UPDATE_DYNAMIC_NFTOKEN:
        onSuccess({ ...body });
        addAlert({
          title: "NFToken Update",
          type: ALERT_TYPES.SUCCESS,
          message: `NFToken Update Was Successful`,
        });
        return;

      case TRANSACTION_OPTIONS.NFTOKEN_OFFER_ACCEPT:
        onSuccess({
          ...response,
          collection: body?.collection,
        });
        addAlert({
          title: "NFToken(s) Claim",
          type: ALERT_TYPES.SUCCESS,
          message: `Successfully Claimed An NFToken`,
        });
        return;

      case TRANSACTION_OPTIONS.NFTOKEN_OFFERS_ACCEPT:
        let remainingOffers = offers.filter((offer, index) => index !== 0);
        onSuccess({
          ...response,
          collection: body.collection,
          offers: remainingOffers,
        });
        addAlert({
          title: "NFToken(s) Claim",
          type: ALERT_TYPES.SUCCESS,
          message: `Successfully Claimed An NFToken`,
        });
        return;

      case TRANSACTION_OPTIONS.SWERL_VOUCHER_OFFERS_ACCEPT:
        /*        let remainingOffers = offers.filter(
            (offer, index) => index !== 0
          ); */

        addAlert({
          title: "Vouchers(s) Claim",
          type: ALERT_TYPES.SUCCESS,
          message: `Successfully Claimed An Voucher`,
        });
        return onSuccess({
          ...response,
          collection: body.collection,
          offers: remainingOffers,
        });

      case TRANSACTION_OPTIONS.DEACTIVATE_USER_ACCOUNT:
        return; /* deactivateUser(body, body.type, {
            txid: data.txid,
            payload: data.payload_uuidv4,
          })
            .then((data) => {
              if (!data.error || data !== false) {
                onSuccess();
                addAlert({
                  title: "User Account Deactivation",
                  type: ALERT_TYPES.SUCCESS,
                  message: `Successfully deactivated account`,
                });
                return;
              }
              addAlert({
                title: "User Account Deactivation",
                type: ALERT_TYPES.SUCCESS,
                message: `Account Deactivation Successful`,
              });
            })
            .catch((err) => {
              onFail();
              addAlert({
                title: "User Account Deactivation",
                type: ALERT_TYPES.DANGER,
                message: `Account Deactivation Unsuccessful`,
              });
            }); */

      case TRANSACTION_OPTIONS.PAY_STREAMING_SUBSCRIPTION:
        addAlert({
          title: "Sonar Muse Streaming Subscription",
          type: ALERT_TYPES.SUCCESS,
          message: `Subscription Payment Successful`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.PAY_AS_YOU_GO_STREAMING_SUBSCRIPTION:
        addAlert({
          title: "Sonar Muse Pay As You Go (PAYG) Streaming Subscription",
          type: ALERT_TYPES.SUCCESS,
          message: `Subscription Payment Successful`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.TOP_UP_STREAMING_SUBSCRIPTION:
        addAlert({
          title: "Sonar Muse Streaming Subscription Top Up",
          type: ALERT_TYPES.SUCCESS,
          message: `Subscription Top Up Successful`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.TOP_UP_TIPPING_FUNDS:
        addAlert({
          title: "Sonar Muse Swərl Tipping Top Up",
          type: ALERT_TYPES.SUCCESS,
          message: `Subscription Top Up Successful`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.REDEEM_SWERL_VOUCHER:
        addAlert({
          title: "Sonar Muse Streaming Subscription",
          type: ALERT_TYPES.SUCCESS,
          message: `Subscription Payment Successful`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.PURCHASE_SWERL_VOUCHER:
        addAlert({
          title: "Purchasing Swerl Streaming Voucher",
          type: ALERT_TYPES.SUCCESS,
          message: `Streaming Voucher Purchase Successful`,
        });
        return onSuccess({ offers: response.offers });

        break;

      case TRANSACTION_OPTIONS.ENABLE_WEB_MONETIZATION:
        addAlert({
          title: "Enabling Web Monetization",
          type: ALERT_TYPES.SUCCESS,
          message: `Web Monetization Successfully Enabled`,
        });
        return onSuccess({
          paymentChannel: response?.paymentChannel,
          funds: response?.funds,
        });

        break;

      case TRANSACTION_OPTIONS.AUTHORIZE_MONETIZATION_CLAIM:
        addAlert({
          title: "Authorization Receipt",
          type: ALERT_TYPES.SUCCESS,
          message: `Authorization Receipt Created Successfully`,
        });
        return onSuccess(response?.hex, response?.signer_pubkey);

        break;

      case TRANSACTION_OPTIONS.AUTHORIZE_MONETIZATION_DISABLE:
        addAlert({
          title: "Authorization Receipt",
          type: ALERT_TYPES.SUCCESS,
          message: `Authorization Receipt Created Successfully`,
        });
        return onSuccess(
          response.payload_uuidv4,
          response.txid,
          response?.hex,
          response?.data?.signer_pubkey,
        );

        break;

      case TRANSACTION_OPTIONS.CLAIM_MONETIZATION_FUNDS:
        //let address = value?.data?.address;
        addAlert({
          title: "Micropayment Funds Claim",
          type: ALERT_TYPES.SUCCESS,
          message: `Micropayments Fund Claim Successful`,
        });
        return onSuccess();
        break;

      case TRANSACTION_OPTIONS.DISABLE_WEB_MONETIZATION:
        break;

      case TRANSACTION_OPTIONS.COLLECTION_WHITELIST:
        addAlert({
          title: "Collection Whitelist",
          type: ALERT_TYPES.SUCCESS,
          message: `Collection whitelist updated successfully`,
        });
        return onSuccess();

        break;

      case TRANSACTION_OPTIONS.GET_MUSIC_LIBRARY:
        //console.log(data)
        let address = response?.address;

        return onSuccess(address);

      case TRANSACTION_OPTIONS.GET_ACCOUNT_INFO:
        return onSuccess(response?.address);

      case TRANSACTION_OPTIONS.NFTOKEN_DISCOUNT:
        //console.log(data)
        return onSuccess(address);

      case TRANSACTION_OPTIONS.PODCASTER_REGISTRATION:
        break;

      case TRANSACTION_OPTIONS.MARKETING_CAMPAIGN:
        addAlert({
          title: "Marketing Campaign",
          type: ALERT_TYPES.DANGER,
          message: `Marketing Campaign Creation Successful`,
        });
        return onSuccess();

        break;

      default:
        return onSuccess(response)
        break;
    }
  };



  const handleSign = async () => {
    setIsWaiting(true);
    try{
    let result =  await core.methods.signTransaction({
        provider,
        chainId: chain, // Matches your provider configuration
        request: {
      tx_json: payload?.memo
        ?  {
            
              SourceTag: 510162502,
              Memos: [
                {
                  Memo: {
                    MemoData: payload.memo,
                  },
                },
              ],
              Account: account,
              TransactionType: "Payment",
              Amount: "1",
              Destination: "rrrrrrrrrrrrrrrrrNAMEtxvNvQ",
          }
         :  payload ,  // Account is required for sign-only,
         options: {
            autofill: true,
            submit: payload?.memo ? false : true,
         }
    },
      })
        const response = result?.result || result;
        if (response?.tx_json) {
          await updateSignTxStatus(invoice, {
            txHash: payload?.memo ? response?.tx_json : response?.tx_json?.hash,
            isOffChain: payload?.memo ? true : false,
            ...response,
            signed: true,
          });
        } else {
          await updateSignTxStatus(invoice, {
            signed: false,
          });
          onFail();
        }
      
      } catch(err){
        console.error("Sign error:", err);
        onFail(); 
        if (err.message.includes("Non conforming namespaces")) {
          alert("Session Expired. Reconnecting...");
         // Force clean state
          await updateSignTxStatus(invoice, {
            txHash: response?.tx_json.hash,
            ...response,
            signed: false,
          });
        }
      }finally{
        setIsWaiting(false);
      }
  };

  return (
    <FormWrapper>
      {(status === "idle" || !status) && (
        <Form>
          <FormH1>{heading}</FormH1>

          <div
            style={{
              textAlign: "center",
              marginBottom: "20px",
              padding: "0 10px",
            }}
          >
            {isWaiting ? (
              <>
                <FormText
                  style={{
                    fontWeight: "bold",
                    marginBottom: "8px",
                  }}
                >
                  Please open Joey Wallet to sign the transaction.
                </FormText>
                <br/>
                <FormText style={{ color: themeColors.accentColor }}>
                  Keep this page open while signing.
                </FormText>
              </>
            ) : (
              <FormText style={{ color: themeColors.accentColor }}>
                Ready to sign with Joey.
              </FormText>
            )}
            
          </div>

          {/* BUTTON (Acts as Manual Retry if auto-trigger missed) */}
          <FormButton
            to={"#"}
            onClick={handleSign}
            disabled={status === "processing"}
          >
            {isWaiting ? "Waiting for Joey... Click to Retry" : "Confirm & Sign"}
          </FormButton>
          {type === TRANSACTION_OPTIONS.SIGN_UP && (
            <>
              <Small>
                New to web3 or the XRPL? Learn more about how to sign up{" "}
                <TextRoute to="/faq"> here</TextRoute>
              </Small>
              <Small>
                Already have an account?{" "}
                <TextRoute to="/access/signin">Sign in</TextRoute>
              </Small>
            </>
          )}
          {type === TRANSACTION_OPTIONS.SIGN_IN && (
            <>
              <Small>
                Don't have an account?{" "}
                <TextRoute to="/access/signup">Sign up</TextRoute>
              </Small>
              <Small>
                Have an artist account? Visit the{" "}
                <TextRoute
                  target="_blank"
                  rel="noopener noreferrer"
                  to="https://artists.sonarmuse.org"
                >
                  Sonar Muse for Artists
                </TextRoute>{" "}
                portal to sign in
              </Small>
            </>
          )}
          <FormButton1 transparent onClick={cancel}>Cancel</FormButton1>
        </Form>
      )}

      {(status === "loading" || status === "processing") && (
        <ModalLoadingScreen
          text={
            status === "processing"
              ? "Processing Transaction. Please Wait..."
              : "Loading. Please Wait..."
          }
          transparent={true}
        />
      )}
    </FormWrapper>
  );
}
